import { useState, useEffect, useRef } from "react";

import Modal from "react-bootstrap/Modal";
import { Button, Form, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";

export default function Eskalationspause({ loading, eskalationsPause, setEskalationsPause, sendSpecificData }) {
   const [show, setShow] = useState(false);
   const [oldEskPause, setOldEskPause] = useState();

   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);

   useEffect(() => {
      setOldEskPause(eskalationsPause);
   }, []);

   return (
      <>
         <button
            className="mt-1 ms-0 eskpause-button w-100"
            title={eskalationsPause["text"]}
            style={
               eskalationsPause.datum && new Date(eskalationsPause.datum) > new Date()
                  ? { backgroundColor: "green", color: "white" }
                  : {}
            }
            onClick={handleShow}
         >
            Aufbereitungspause{" "}
            {eskalationsPause["datum"] && new Date(eskalationsPause["datum"]) > new Date() && (
               <>
                  <br />
                  <strong>bis {new Date(eskalationsPause["datum"]).toLocaleString()}</strong>
               </>
            )}
         </button>

         <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
               <Modal.Title>Aufbereitungspause</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <Form>
                  <Form.Group className="mb-3" key="abc">
                     <Form.Label>Begründung für die Pause</Form.Label>
                     <Form.Control
                        as="textarea"
                        placeholder=""
                        onChange={(e) =>
                           setEskalationsPause((prev) => ({
                              ...prev,
                              ["text"]: e.target.value,
                           }))
                        }
                        name="text"
                        value={eskalationsPause["text"]}
                        style={{ height: "100px" }}
                     />
                  </Form.Group>

                  <Form.Group controlId={"id_1"} className="mb-3">
                     <Form.Label>Zeitstempel</Form.Label>

                     <DatePicker
                        isClearable
                        selected={eskalationsPause["datum"] ? new Date(eskalationsPause["datum"]) : false}
                        showTimeSelect
                        timeIntervals={60}
                        onChange={(e) => setEskalationsPause((prev) => ({ ...prev, ["datum"]: e }))}
                        className="bootstrap-datepicker"
                        calendarClassName="custom-date-calendar"
                        timeFormat="HH:mm"
                        dateFormat="dd.MM.yyyy, HH:mm"
                        locale="de"
                     />
                  </Form.Group>
               </Form>
            </Modal.Body>
            <Modal.Footer>
               <Button
                  variant="secondary"
                  onClick={() => {
                     setEskalationsPause(oldEskPause);
                     handleClose();
                  }}
               >
                  Abbrechen
               </Button>
               <Button
                  variant="primary"
                  disabled={loading || (eskalationsPause["datum"] && !eskalationsPause["text"])}
                  onClick={async () => {
                     await sendSpecificData("eskalationspause", eskalationsPause);
                     handleClose();
                  }}
               >
                  Speichern
               </Button>
            </Modal.Footer>
         </Modal>
      </>
   );
}
